import React, { Component } from "react";

// Styles
import "./Options.scss";

// Components
import Button from "components/Button";

// Icons
//import PlayIcon from 'static/icons/play-icon.svg'
import UpArrow from "static/img/upperDirection.svg";
import RotateClockwiseIcon from "static/img/rotate2icon.svg";
import Downwards from "static/img/downwards.svg";
import Smash from "static/img/smash.svg";
import PlayDirectory from "static/img/p1.svg";
import RotateAntiClockwiseIcon from "static/img/antirotate3icon.svg";
// import CircularRedCloseIcon from 'static/img/circular-red-close-icon.svg'
import DashedCircle from "static/img/dashed-circle.svg";
import DashedCircle2 from "static/img/mobile-dashed.svg";
import RunBtn from "static/img/runbtn.svg";
// Needs to be replaced
import StopIcon from "static/img/stopBtn.svg";

import { ButtonSound } from "../../utility/sounds";

class Options extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainMethodTilesArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      loopMethodTilesArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      activeCard: props.procedure ? "Loop" : "Main",
      mainMoves: [],
      loopMoves: [],
      numberOfMainUndos: 0,
      numberOfLoopUndos: 0,
      isMobileView: false,
      showProc1Warning: false,
    };
  }

  componentDidMount() {
    if (window.screen.width < 1024) {
      this.setState({ isMobileView: true });
      this.reInitBigArray(this.props.currentLevel, true);
    } else {
      this.reInitBigArray(this.props.currentLevel, false);
    }
    let _self = this;
    window.addEventListener("resize", function () {
      if (window.screen.width < 1024) {
        _self.setState({ isMobileView: true });
        _self.reInitBigArray(_self.props.currentLevel, true);
      } else {
        _self.setState({ isMobileView: false });
        _self.reInitBigArray(_self.props.currentLevel, false);
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", function () {});
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.currentLevel !== this.props.currentLevel) {
      this.reInitBigArray(nextProps.currentLevel);
    }
    return true;
  }

  reInitBigArray(currentLevel = this.props.currentLevel, mobile = false) {
    /*let isMobile = mobile
    if (window.screen.width < 1024) {
      isMobile = true
    }*/
    let mainMethodArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    let loopMethodArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    /*switch (currentLevel) {
      case 1:
        if (isMobile) {
          mainMethodArr = [1, 2, 3, 4, 5, 6, 7, 8]
          loopMethodArr = [1, 2, 3, 4, 5, 6, 7, 8]
        }
        break;
      case 2:
        mainMethodArr = [1, 2, 3, 4]
        loopMethodArr = [1, 2, 3, 4]
        break;
      case 3:
        mainMethodArr = [1]
        loopMethodArr = [1, 2, 3, 4, 5, 6, 7, 8]
        break;
      default:
        break;
    }*/
    this.setState({
      mainMethodTilesArray: mainMethodArr,
      loopMethodTilesArray: loopMethodArr,
    });
  }

  emptyMoves() {
    this.setState({ mainMoves: [], loopMoves: [] });
  }

  addMove(move) {
    ButtonSound();
    if (!this.props.areMovesDisabled) {
      let arr = [];
      if (this.state.activeCard === "Main") {
        arr = this.state.mainMoves;
        if (arr.length < this.state.mainMethodTilesArray.length) {
          arr.push(move);
          this.setState({
            mainMoves: arr,
          });
        }
      } else if (this.state.activeCard === "Loop") {
        arr = this.state.loopMoves;
        if (arr.length === 0 && move === "PROCEDURE") {
          this.setState({
            showProc1Warning: true,
          });
          setTimeout(() => {
            this.setState({
              showProc1Warning: false,
            });
          }, 3000);
        } else if (arr.length < this.state.loopMethodTilesArray.length) {
          arr.push(move);
          this.setState({
            loopMoves: arr,
          });
        }
      }
    }
  }

  playButtonClickHandler() {
    ButtonSound();
    if (this.state.mainMoves.length > 0) this.props.begin();
    if (this.state.mainMoves.length > 0) {
      if (this.state.loopMoves.length > 0) {
        this.props.PlayMoves(this.state.mainMoves, this.state.loopMoves);
      } else this.props.PlayMoves(this.state.mainMoves, []);
    } else {
      let n = localStorage.getItem("pressedPlayButtonWithEmptyLoops")
        ? localStorage.getItem("pressedPlayButtonWithEmptyLoops")
        : 1;
      localStorage.setItem("pressedPlayButtonWithEmptyLoops", n);
    }
  }

  getMoveIcon(move) {
    switch (move) {
      case "FORWARD":
        return UpArrow;
      case "CLOCKWISE":
        return RotateClockwiseIcon;
      case "ANTICLOCKWISE":
        return RotateAntiClockwiseIcon;
      case "LIGHT":
        return Smash;
      case "JUMP":
        return Downwards;
      case "PROCEDURE":
        return PlayDirectory;
      default:
        return UpArrow;
    }
  }
  removeMove() {
    if (this.state.activeCard === "Main") this.removeMoveFromMain();
    else this.removeMoveFromLoop();
  }
  removeMoveFromMain() {
    const index = this.state.mainMoves.length - 1;
    ButtonSound();
    let arr = [...this.state.mainMoves];
    arr.splice(index, 1);
    this.setState({
      mainMoves: arr,
      numberOfMainUndos: this.state.numberOfMainUndos + 1,
    });
    var n = localStorage.getItem("undos") ? localStorage.getItem("undos") : 1;
    localStorage.setItem("undos", n);
  }

  removeMoveFromLoop() {
    const index = this.state.loopMoves.length - 1;
    ButtonSound();
    let arr = [...this.state.loopMoves];
    arr.splice(index, 1);
    this.setState({
      loopMoves: arr,
      numberOfLoopUndos: this.state.numberOfLoopUndos + 1,
    });
    var n = localStorage.getItem("undos") ? localStorage.getItem("undos") : 1;
    localStorage.setItem("undos", n);
  }

  getMainMethodMoveBorder(index) {
    const { currentActiveMove } = this.props;

    if (currentActiveMove.method === "MAIN") {
      if (currentActiveMove.index === index) {
        return "solid 2px #00cdff";
      }
    }

    return "none";
  }

  getLoopMethodMoveBorder(index) {
    const { currentActiveMove } = this.props;

    if (currentActiveMove.method === "LOOP") {
      if (currentActiveMove.index === index) {
        return "solid 2px #00cdff";
      }
    }

    return "none";
  }

  getMainCardContent = (card) => {
    const { mainMoves, loopMoves } = this.state;

    const { currentActiveMove } = this.props;
    const movesArray = card === "Main" ? mainMoves : loopMoves;
    return (
      <div className="main-card__content--moves">
        {this.state.mainMethodTilesArray
          .map((value, index) => index)
          .map((item) => {
            return (
              <div
                className={`
                move-icon 
                ${
                  movesArray[item] &&
                  currentActiveMove.move === movesArray[item] &&
                  currentActiveMove.index === item
                    ? "active"
                    : ""
                }
                ${movesArray[item] ? "" : "dashed-circle"}
              `}
                key={item}
              >
                {movesArray[item] ? (
                  <img src={this.getMoveIcon(movesArray[item])} alt="Move icon" />
                ) : (
                  <img src={DashedCircle} alt="Dashed circular icon" />
                )}
              </div>
            );
          })}
        {/* <img
          src={CircularRedCloseIcon}
          alt="Close icon"
          className="main-card__content--clear-icon"
          onClick={() => this.removeMoveFromMain(mainMoves.length - 1)}
        /> */}
      </div>
    );
  };

  getResponsiveMainCardContent = (card) => {
    const { mainMoves, loopMoves } = this.state;
    const movesArray = card === "Main" ? mainMoves : loopMoves;
    const { currentActiveMove } = this.props;

    return (
      <>
        <div className="main-card__content--moves">
          {this.state.mainMethodTilesArray
            .map((value, index) => index)
            .map((item) => {
              return (
                <div
                  className={`
                move-icon 
                ${
                  movesArray[item] &&
                  currentActiveMove.move === movesArray[item] &&
                  currentActiveMove.index === item
                    ? "active"
                    : ""
                }
                ${movesArray[item] ? "" : "dashed-circle"}
              `}
                  key={item}
                >
                  {movesArray[item] ? (
                    <img src={this.getMoveIcon(movesArray[item])} alt="Move icon" />
                  ) : (
                    <img src={DashedCircle2} alt="Dashed circular icon" />
                  )}
                </div>
              );
            })}
        </div>
        {/* {mainMoves.length > 0
          &&
          <img
            src={CircularRedCloseIcon}
            alt="Close icon"
            className="main-card__content--clear-icon"
            onClick={() => this.removeMoveFromMain(mainMoves.length - 1)}
          />
        } */}
      </>
    );
  };

  render() {
    const { activeCard, isMobileView } = this.state;
    const { isPlaying } = this.props;

    // const {
    //   showStopIcon = false,
    //   onStopClick,
    //   onRefreshClick,
    //   currentActiveMove
    // } = this.props

    return (
      <div className="options-component">
        <div
          className={`main-card without-bordered main-for-mobile  for-mobile ${
            activeCard === "Main" ? "fix-box2" : "fix-box"
          }`}
          onClick={() => this.setState({ activeCard: "Main" })}
        >
          <div className="main-card__title">
            <p className="main-card__title--text">Main</p>
          </div>
          <div className="main-card__content">
            {isMobileView
              ? this.getResponsiveMainCardContent("Main")
              : this.getMainCardContent("Main")}
          </div>
        </div>
        {this.props.procedure && (
          <div
            className={`main-card without-bordered for-mobile2 ${
              activeCard === "Loop" ? "fix-box2" : "fix-box"
            }`}
            onClick={() => this.setState({ activeCard: "Loop" })}
          >
            {this.state.showProc1Warning && (
              <div className="proc1-toast">This would lead to a syntax error.</div>
            )}
            <div className="main-card__title">
              <p className="main-card__title--text">Proc1</p>
            </div>
            <div className="main-card__content">
              {isMobileView
                ? this.getResponsiveMainCardContent("Loop")
                : this.getMainCardContent("Loop")}
            </div>
          </div>
        )}

        <div className="move-card main-card">
          <div className="move-card__title">
            <p className="move-card__title--text">Commands</p>
          </div>
          <div className="move-card__content">
            <div className="move-card__content--left-container">
              <Button
                className="btn btn__square--md btn__image margin"
                onClick={() => this.addMove("FORWARD")}
              >
                <img src={UpArrow} alt="Forward icon" />
              </Button>
              <Button
                className="btn btn__square--md btn__image margin"
                onClick={() => this.addMove("CLOCKWISE")}
              >
                <img src={RotateClockwiseIcon} alt="Clockwise rotation icon" />
              </Button>
              <Button
                className="btn btn__square--md btn__image margin"
                onClick={() => this.addMove("ANTICLOCKWISE")}
              >
                <img src={RotateAntiClockwiseIcon} alt="Anti Clockwise rotation icon" />
              </Button>
              <Button
                className="btn btn__square--md btn__image margin"
                onClick={() => this.addMove("JUMP")}
              >
                <img src={Downwards} alt="Jump icon" />
              </Button>
              <Button
                className="btn btn__square--md btn__image margin"
                onClick={() => this.addMove("LIGHT")}
              >
                <img src={Smash} alt="Light icon" />
              </Button>
              <Button
                  className="btn btn__square--md btn__image margin runbtn"
                  onClick={this.props.runBot}
                >
                  <img src={RunBtn} alt="runbtn" />
                </Button>
              {/* {
                !isPlaying ? 
                <Button
                  className="btn btn__square--md btn__image margin runbtn"
                  onClick={this.props.runBot}
                >
                  <img src={RunBtn} alt="runbtn" />
                </Button>:
                <Button
                  className="btn btn__square--md btn__image margin runbtn"
                  onClick={this.props.stopBot}
                >
                  <img src={StopIcon} alt="runbtn" />
                </Button>
              } */}
              {this.props.procedure && (
                <Button
                  className="btn btn__square--md btn__image margin"
                  onClick={() => this.addMove("PROCEDURE")}
                >
                  <img src={PlayDirectory} alt="Procedure icon" />
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Options;
